import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft, Loader2, BookOpen } from "lucide-react";
import CityCoversCarousel from "../components/CityCoversCarousel";

/**
 * Página que substitui o antigo GuideViewer (PDF):
 * agora exibe um carrossel estiloso das capas das edições impressas
 * do guia da cidade. Admin cadastra múltiplas capas em /admin/cities.
 */
export default function GuideViewer() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/cities/${slug}`)
      .then((r) => setCity(r.data))
      .catch(() => setError("Cidade não encontrada"))
      .finally(() => setLoading(false));
  }, [slug]);

  // Suporta o legado: se ainda houver apenas guide_cover_url, transforma em 1 capa
  const covers = (() => {
    if (!city) return [];
    if (Array.isArray(city.guide_covers) && city.guide_covers.length > 0) return city.guide_covers;
    if (city.guide_cover_url) return [{ url: city.guide_cover_url, edition: city.guide_title || "Edição 1", year: null, order: 0 }];
    return [];
  })();

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-950 via-blue-950 to-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3 sm:py-4 flex items-center gap-2 sm:gap-3">
        <button
          onClick={() => nav(-1)}
          className="inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-2 rounded-xl text-xs sm:text-sm bg-white/10 hover:bg-white/20"
          data-testid="guide-back"
        >
          <ArrowLeft size={14}/><span className="hidden sm:inline">Voltar</span>
        </button>
        <div className="flex-1 min-w-0">
          <h1 className="font-display text-base sm:text-2xl font-bold truncate" data-testid="guide-title">
            {city?.guide_title || (city ? `Guia ${city.name}` : "Guia da cidade")}
          </h1>
          <p className="text-[10px] sm:text-xs text-white/60">
            {city?.name}{city?.state ? ` · ${city.state}` : ""}{covers.length > 0 ? ` · ${covers.length} ${covers.length === 1 ? "edição" : "edições"} impressas` : ""}
          </p>
        </div>
        <span className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-400/10 text-amber-300 border border-amber-400/20 text-xs font-bold">
          <BookOpen size={13}/> Edições do guia impresso
        </span>
      </div>

      <div className="max-w-6xl mx-auto px-3 sm:px-6 py-6 sm:py-10">
        {loading && (
          <div className="flex flex-col items-center justify-center gap-3 text-white/70 py-24">
            <Loader2 size={42} className="animate-spin"/>
            <p className="text-sm">Carregando capas...</p>
          </div>
        )}
        {error && (
          <div className="text-center max-w-md mx-auto p-8 bg-red-500/10 border border-red-500/30 rounded-2xl">
            <p className="font-semibold text-red-200">{error}</p>
          </div>
        )}
        {!loading && !error && (
          <CityCoversCarousel covers={covers} cityName={city?.name || ""}/>
        )}
      </div>
    </div>
  );
}
